import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function VisitorCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancel = false;
    const alreadyCounted = sessionStorage.getItem("gor_visit_counted") === "1";
    const call = alreadyCounted
      ? api.get("/visits")
      : api.post("/visits/increment");

    call
      .then((r) => {
        if (cancel) return;
        sessionStorage.setItem("gor_visit_counted", "1");
        setCount(r.data?.count ?? 0);
      })
      .catch(() => {});

    return () => { cancel = true; };
  }, []);

  return (
    <div
      data-testid="visitor-counter"
      className="relative border-t border-white/10 bg-navy-deep text-white/80"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="label-overline text-[#C6A87C]">Total visitors</div>
        <div className="font-serif text-4xl text-white tracking-tight">
          {count === null ? "—" : count.toLocaleString("en-IN")}
        </div>
        <div className="text-xs uppercase tracking-[0.18em] text-white/40 font-mono-tech">
          Updated in real-time
        </div>
      </div>
    </div>
  );
}
